

















import { Component, Prop } from 'vue-property-decorator';

import {UserProfile} from "@api/models/UserProfile";
import {User} from "@api/models/User";
import {AppercodeFile} from "@api/models/File";
import {IsMeetingsEnabled} from "@mixins/isMeetingsEnabled";
import {ProfileField} from "../../../types/ProfileField";

import Info from "./components/info-part/InfoPart.vue";
import Interests from "./components/interests-part/InterestsPart.vue";
import Settings from "./components/settings-part/SettingsPart.vue";
import DeviceTest from "./components/device-test-part/DeviceTestPart.vue";

import { SettingsViewPart } from "./types/SettingsViewPart"

@Component({
    components: { Info, Interests, Settings, DeviceTest }
})
export default class SettingsForm extends IsMeetingsEnabled {
    @Prop({required: true}) profile: UserProfile;
    @Prop({required: true}) user: User;
    @Prop({required: true}) fields: Array<ProfileField>;
    @Prop({default: () => []}) tags: object[];
    @Prop({default: () => ({})}) termsOfUse: object;
    @Prop({required: true}) isLoaded: boolean;
    @Prop({required: true}) validationMessages: Record<string, string>;
    @Prop({required: true}) partName: SettingsViewPart;
    @Prop() buttonText: string | undefined;

    userId = this.$store.state.session.userId;
    originProfileString = '';

    async onPhotoChanged(value: AppercodeFile) {
        this.profile.photoFileId = value.id;
        this.$emit('profilePhotoChanged', false);
    }

    async logout() {
        this.$clearAllBodyScrollLocks();
        this.$store.dispatch('resetSession');
        this.$router.push({name: 'Login', params: this.$route.params});
    }

    caption(field: ProfileField) {
        const language = this.$store.state.session?.language ?? 'en';

        return field && field.title && field.title[language]
            ? field.title[language]
            : this.$t('settings.' + field.name.toLowerCase());
    }
}
